<div class="license-totals tw-flex">
  <div class="count-container tw-flex-1">
    <p class="count-container__label">Unlimited</p>
    <p class="count-container__count">
      <span
        [class.remaining]="
          companyAllocationService.getRemainingLicenses('unlimited') > 0
        "
        id="unlimited-remaining-licenses"
      >
        {{ companyAllocationService.getRemainingLicenses('unlimited') }}
      </span>
      <span class="purchased" id="unlimited-purchased-licenses">
        / {{ companyAllocationService.getPurchasedLicenses('unlimited') }}
      </span>
      <span>Remaining</span>
    </p>
  </div>
  <rv-divider vertical></rv-divider>
  <div class="count-container tw-flex-1">
    <p class="count-container__label">Individual</p>
    <p class="count-container__count">
      <span
        [class.remaining]="
          companyAllocationService.getRemainingLicenses('enterprise') > 0
        "
        id="enterprise-remaining-licenses"
      >
        {{ companyAllocationService.getRemainingLicenses('enterprise') }}
      </span>
      <span class="purchased" id="enterprise-purchased-licenses">
        / {{ companyAllocationService.getPurchasedLicenses('enterprise') }}
      </span>
      <span>Remaining</span>
    </p>
  </div>
  <rv-divider vertical></rv-divider>
  <div class="tw-flex tw-items-center">
    <button
      mat-raised-button
      color="primary"
      class="tw-w-full"
      id="purchase-licenses"
      [shown]="
        !companyAllocationService.loading &&
        !companyAllocationService.isManagedByParent
      "
      type="button"
      (click)="companyAllocationService.purchaseLicenses(false)"
    >
      Purchase Licenses
    </button>
  </div>
</div>
